import { useEffect, useId, useState } from 'react';

interface Props {
  label: string;
  value: number;
  onChange: (n: number) => void;
  prefix?: string;
  suffix?: string;
  hint?: string;
  min?: number;
}

const show = (n: number) => (Number.isFinite(n) ? String(n) : '');

/** A number box that lets you clear it and type freely; empty counts as 0. */
export function NumberField({ label, value, onChange, prefix, suffix, hint, min = 0 }: Props) {
  const id = useId();
  const [text, setText] = useState(show(value));

  useEffect(() => {
    // Follow outside changes (loading another car) but not our own typing.
    setText((t) => (Number(t || 0) === value ? t : show(value)));
  }, [value]);

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="input-wrap">
        {prefix && <span className="affix">{prefix}</span>}
        <input
          id={id}
          type="text"
          inputMode="decimal"
          value={text}
          aria-describedby={hint ? `${id}-hint` : undefined}
          onChange={(e) => {
            const raw = e.target.value;
            if (!/^-?\d*\.?\d*$/.test(raw)) return;
            setText(raw);
            const n = raw === '' || raw === '-' || raw === '.' ? 0 : Number(raw);
            onChange(Math.max(min, n));
          }}
          onBlur={() => setText(show(value))}
        />
        {suffix && <span className="affix">{suffix}</span>}
      </div>
      {hint && <small id={`${id}-hint`}>{hint}</small>}
    </div>
  );
}
